import { pxToRem } from '@fluentsms/agentnet-web-components';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { filePartyTypeMap, Party, PartyOrderInsightsProps } from 'api/file/interfaces/get-file-order-insights';
import PartyOrderInsights from 'features/files/order-insights/PartyOrderInsights';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      paddingTop: pxToRem(16),
    },
    partiesDetailsContainer: {
      display: 'flex',
      gap: '4px',
      flexDirection: 'column',
      '& p, h2': {
        margin: 0,
      },
    },
    partiesDetails: {
      display: 'flex',
      flexDirection: 'row',
      gap: pxToRem(12),
      fontSize: pxToRem(12),
      marginBottom: pxToRem(8),
      color: theme.palette.text.secondary,
    },
    partyName: {
      color: theme.palette.text.primary,
      fontSize: pxToRem(16),
      fontStyle: 'normal',
      fontWeight: 800,
      lineHeight: 'normal',
      letterSpacing: pxToRem(1),
    },
  }),
);

interface IParties {
  party: Party;
  enableStatus?: PartyOrderInsightsProps['enableStatus'];
  timezone?: string;
}

const Parties = ({ party, enableStatus, timezone }: IParties) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.partiesDetailsContainer}>
        <h2 className={classes.partyName}>{party.partyName}</h2>
        <div className={classes.partiesDetails}>
          <p>{filePartyTypeMap[party.filePartyType]}</p>
          <p>{party.partyType}</p>
        </div>
      </div>

      <div>
        <PartyOrderInsights isPdf party={party} enableStatus={enableStatus} timezone={timezone ?? ''} />
      </div>
    </div>
  );
};

export default Parties;
